import React, { useState, useContext } from 'react';
import styled from 'styled-components';
import { Icon, IconName } from '@usealloy/component-library';
import { Colors } from '~/constants';
import { UserContext } from '~/dashboard/context';

const StyledActionData = styled.td<{
  isActive: boolean;
  disabled?: boolean;
}>`
  height: 3.5rem;
  width: 3.5rem;
  background-color: ${props => (props.isActive ? Colors.DISABLED_GREY : Colors.WHITE)};
  z-index: ${props => (props.isActive ? 1 : 'initial')};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'inherit')};
`;

const ActionButtonWrapper = styled.button<{
  isActive: boolean;
}>`
  display: flex;
  align-items: center;
  border: none;
  margin-left: -.75rem;
  margin-top: .25rem;
  cursor: inherit;
  && {
    background: ${props => (props.isActive ? Colors.DISABLED_GREY : Colors.WHITE)};
  }
`;

const StyledDropdownMenu = styled.menu`
  margin-left: -2.5rem;
`;

const StyledMenuItem = styled.button`
  background: ${Colors.WHITE};
  height: 3.25rem;
  width: 15rem;
  margin-left: -13.05rem;
  border: none;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  text-transform: unset;
  font-weight: 400;
  & :first-child {
    margin-top: 1.5rem;
  }
`;

interface ActionButtonProps {
  isActionable: boolean;
  changeStatus(): void;
  canUpdateStatus: boolean;
  openMetaModal(): void;
  hasMetadata: boolean;
  openEvidenceModal?: () => void;
}

const ActionButton: React.FC<ActionButtonProps> = ({
  isActionable,
  changeStatus,
  canUpdateStatus,
  openMetaModal,
  hasMetadata,
  openEvidenceModal,
}) => {
  const [displayDropdownMenu, setDisplayChangeStatus] = useState(false);
  const { featureFlags } = useContext(UserContext);
  return (
    <StyledActionData isActive={displayDropdownMenu}>
      <div>
        <ActionButtonWrapper
          isActive={displayDropdownMenu}
          aria-label="TRX Action Button"
          onClick={() => {
            setDisplayChangeStatus(!displayDropdownMenu);
          }}
        >
          <Icon
            icon={IconName.More}
            title="TRX Action Button"
            width={24}
            height={24}
            color={Colors.PRIMARY_PURPLE}
            aria-hidden
          />
        </ActionButtonWrapper>
        {displayDropdownMenu && (
          <StyledDropdownMenu>
            {canUpdateStatus && (
              <StyledMenuItem disabled={!isActionable} onClick={changeStatus}>
                Change Status
              </StyledMenuItem>
            )}
            <StyledMenuItem disabled={!hasMetadata} onClick={openMetaModal}>
              View Additional Data
            </StyledMenuItem>
            {featureFlags?.addEvidenceToTrxsAndBas && (
            <StyledMenuItem onClick={openEvidenceModal}>
              Add Evidence
            </StyledMenuItem>
            )}
          </StyledDropdownMenu>
        )}
      </div>
    </StyledActionData>
  );
};

export default ActionButton;
